import React, { useState, useEffect } from 'react';
import { AdUnit } from './AdUnit';

const AD_SLOT_RESULTS_INFEED   = '7565129435'; // In-feed – fluid
const AD_SLOT_RESULTS_MULTIPLEX = '2763381438'; // Multiplex – autorelaxed

export function ResultsDisplay() {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchResults();
  }, []);

  const fetchResults = async () => {
    try {
      const res = await fetch('https://should-i-get-reparations-backend.vercel.app/api/results');
      const data = await res.json();
      if (data.success) {
        setResults(data.data);
      }
    } catch (err) {
      console.error('Failed to fetch results:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading results…</div>;
  if (!results) return <div className="loading">No results available yet.</div>;

  return (
    <div className="results-container">
      <div className="results-summary">
        <h2>Voting Results</h2>
        <div className="stats-grid">
          <div className="stat-card">
            <h3>{results.total_votes.toLocaleString()}</h3>
            <p>Total Votes</p>
          </div>
          <div className="stat-card">
            <h3>{results.total_persons.toLocaleString()}</h3>
            <p>People Entered</p>
          </div>
        </div>
      </div>

      {/* In-feed ad between stats and leaderboard */}
      <AdUnit slot={AD_SLOT_RESULTS_INFEED} format="fluid" layoutKey="-64+e4+4c-j1+60" />

      <div className="top-performers">
        <h3>🏆 Top Performers</h3>
        <div className="results-grid">
          {results.top_persons.map((person, index) => (
            <div key={person.id} className="result-card">
              <img
                src={person.photo_url}
                alt={`Person ${index + 1}`}
                className="result-image"
                loading="lazy"
              />
              <div className="result-info">
                <h4>
                  {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                </h4>
                <div className="result-stats">
                  <p>
                    <strong>{person.vote_count}</strong> votes
                  </p>
                  <p>{person.percentage.toFixed(1)}% of total</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {results.recent_votes.length > 0 && (
        <div className="recent-votes">
          <h3>⚡ Recent Activity</h3>
          <div className="activity-list">
            {results.recent_votes.slice(0, 5).map((vote, index) => (
              <div key={index} className="activity-item">
                <span className="activity-time">
                  {new Date(vote.timestamp).toLocaleString()}
                </span>
                <span className="activity-action">
                  Vote recorded for …{vote.person_id.slice(-4)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Multiplex (content recommendation) ad at the bottom */}
      <AdUnit slot={AD_SLOT_RESULTS_MULTIPLEX} format="autorelaxed" />
    </div>
  );
}
